import { BaseModel } from './BaseModel';

export class ChangeRequest extends BaseModel {
  static get entity() {
    return 'change_request';
  }

  static get fk() {
    return 'request_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      user: this.attr(null),
      change_type: this.attr(null),
      request_date: this.attr(null),
      status: this.attr(null),
      request_data: this.attr(null),
      verify_token: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      getChangeRequest(params = {}) {
        return this.get('/change-requests', { params }, { save: false });
      },
      getChangeRequestById(requestId) {
        return this.get(`/change-requests/${requestId}`, { save: false });
      },
      changeName({ firstname, lastname }) {
        return this.submitChangeRequest('ProfileNameUpdate', { firstname, lastname });
      },
      isEligible(changeType) {
        return this.get(`/change-requests/eligibility`, {
          params: { changeType: changeType },
          save: false
        });
      },
      isChangeNameAble() {
        return this.isEligible('ProfileNameUpdate');
      },
      isChangeEmailAble() {
        return this.isEligible('ProfileEmailUpdate');
      },
      submitChangeRequest(changeRequestType, requestData = {}) {
        return this.post(
          '/change-requests',
          {
            changeRequestType,
            requestData
          },
          {
            dataTransformer: (response) => {
              const { data } = response.data;

              return data;
            }
          }
        );
      },
      verifyRequestChange({ token }) {
        return this.post(`/change-requests/verification`, { token }, { save: false });
      },
      resendVerifyRequestChange(id) {
        return this.put(`/change-requests/${id}/verification`, {}, { save: false });
      },
      requestChange({ changeRequestType, requestData }) {
        return this.post('/change-requests', { changeRequestType, requestData }, { save: false });
      },
      getChangeRequestPublicData(requestId) {
        return this.get(`/change-requests/${requestId}/public`, { save: false });
      }
    }
  };
}

export default ChangeRequest;
